export default __webpack_public_path__ + "static/media/Frame 4.1844b1a4.svg";